module.exports = __webpack_public_path__ + "img/护理-9.f2129041.png";